import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useMotivoAfastamentoFilters
 */

type State = {
  tipoPesquisa: number;
  motivoAfastamento: string;
  status: number;
};

type Action = {
  setTipoPesquisa: (tipoPesquisa: number) => void,
  setMotivoAfastamento: (motivoAfastamento: string) => void,
  setStatus: (status: number) => void,
};

export const useMotivoAfastamentoFilters = create<State & Action>((set) => ({
  tipoPesquisa: 1,
  motivoAfastamento: "",
  status: 2,
  setTipoPesquisa: (tipoPesquisa) => set({ tipoPesquisa }),
  setMotivoAfastamento: (motivoAfastamento) => set({ motivoAfastamento }),
  setStatus: (status) => set({ status }),
}));